module.exports = __webpack_public_path__ + "img/goods02.218302fa.png";